var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('mf-action-buttons',{attrs:{"primary-button":_vm.primaryButton,"secondary-button":_vm.secondaryButton,"extra-button":_vm.extraButton,"cancel-button":{
      text: 'Cancelar',
      action: function () { return _vm.$emit('cancel'); },
      isVisible: !_vm.readOnly,
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }